module.exports = __webpack_public_path__ + "img/code-12.bcf3ba18.png";